import DateFnsUtils from '@date-io/date-fns';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import { ParsableDate } from '@material-ui/pickers/constants/prop-types';
import { zeroTime } from 'jec-common/lib/utils/date-utils';
import React from 'react';

export interface IDatePickerProps {
  value?: ParsableDate;
  disabled?: boolean;
  onChange?: (value: Date | null) => void;
}

export const DatePicker = (props: IDatePickerProps): JSX.Element => {
  const handleChange = (value: Date | null) => {
    if (props.onChange) {
      props.onChange(zeroTime(value));
    }
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        disabled={props.disabled}
        autoOk={true}
        variant="inline"
        inputVariant="outlined"
        value={props.value}
        format="MM-dd-yyyy"
        InputAdornmentProps={{ position: 'end' }}
        onChange={handleChange}
      />
    </MuiPickersUtilsProvider>
  );
};
